import React from "react";

export function BackButtonIcon(): React.ReactElement {
  return (
    <svg
      id="noun_back_button_2473144"
      data-name="noun_back button_2473144"
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27.913 19.035"
      fill="currentColor"
    >
      <path
        id="Path_2360"
        data-name="Path 2360"
        d="M50.292,40.479H25.2l7.789-7.789a.638.638,0,1,0-.9-.9L23.2,40.666s-.006.011-.01.016a.621.621,0,0,0-.176.436h0a.635.635,0,0,0,.049.243.644.644,0,0,0,.138.207l8.879,8.881a.638.638,0,1,0,.9-.9L25.2,41.756H50.292a.638.638,0,1,0,0-1.277Z"
        transform="translate(-23.018 -31.601)"
      />
    </svg>
  );
}
